function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import React from 'react';
export function SkeletonParagraph(props) {
  var className = props.className,
      width = props.width,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 2 : _props$rows,
      extra = _objectWithoutProperties(props, ["className", "width", "rows"]);

  var getWidth = function getWidth(index) {
    if (Array.isArray(width)) {
      return width[index];
    }

    if (rows - 1 === index) {
      return width;
    }

    return undefined;
  };

  var prefixCls = usePrefixCls('skeleton-paragraph');
  var cls = classnames(prefixCls, className);
  var numbers = Object.keys(Array.from({
    length: rows
  }));
  var rowList = numbers.map(function (value, index) {
    return React.createElement("li", {
      key: index,
      style: {
        width: getWidth(index)
      }
    });
  });
  return React.createElement("ul", Object.assign({
    className: cls
  }, extra), rowList);
}